<template>
  <div>
    <div class="modal-body modal-primary" >
        <div class="export-button row">
            <div class="form-group has-feedback col-xs-8">
                <el-select v-model="selectedUrl" clearable placeholder="请选择" style="width:100%">
                  <el-option
                    v-for="item in types"
                    :key="item.type"
                    :label="item.type"
                    :value="item.url">
                  </el-option>
                </el-select>
            </div>
            
          <button type="button" class="col-xs-4 btn btn-info" v-clipboard:copy="selectedUrl" style="width:33%">Copy To Clipboard</button>      
        </div>
        <div class="well get-badge" id="clipboard" style="overflow-y:scroll">
            <p>
                {{selectedUrl}}
            </p>
        </div>
    </div>
    <div class="modal-body modal-primary">
        <img :src='badgeUrl' alt='CLA assistant' />
    </div>
  </div> 
</template>

<script>
export default {
  props:{
    repo:{}
  },
  data() {
    return {
      selectedUrl:'',
      badgeUrl: window.location + 'readme/badge/' + this.repo.owner + '/' + this.repo.repo,
      linkUrl:window.location + this.repo.owner + '/' + this.repo.repo,
    };
  },

  methods: {
    copy() {
        var inputText = document.getElementById('clipboard');
        var currentFocus = document.activeElement;
        inputText.focus();
        inputText.setSelectionRange(0, inputText.value.length);
        document.execCommand('copy', true);
        currentFocus.focus();
    }
  },
  computed:{
    types(){
      return [{
            type: 'HTML',
            url: '<a href="' + this.linkUrl + '"><img src="' + this.badgeUrl + '" alt="CLA assistant" /></a>'
        }, {
            type: 'Image URL',
            url: this.badgeUrl
        }, {
            type: 'Markdown',
            url: '[![CLA assistant](' + this.badgeUrl + ')](' + this.linkUrl + ')'
        }, {
            type: 'Textile',
            url: '!' + this.badgeUrl + '(CLA assistant)!:' + this.linkUrl
        }, {
            type: 'RDOC',
            url: '{<img src="' + this.badgeUrl + '" alt="CLA assistant" />}[' + this.linkUrl + ']'
        }]
    } 
  }
}

</script>
<style>
</style>


// WEBPACK FOOTER //
// src/javascript/home/components/modal/badge.vue